import ClickableContainer from 'components/clickable-container';
import React from 'react';
import t from 'react-translate';

interface EmptyReportProps {
  showSetupModal?: () => void;
}

const EmptyReport: React.FC<EmptyReportProps> = ({ showSetupModal }) => {
  const [prefix, suffix] = t.COURSE_ANALYTICS.PRE_POST.EMPTY('LINK').split('LINK');
  return (
    <div className='empty d-flex align-items-center justify-content-center py-7 bg-gray-5 mx-auto mt-2'>
      {prefix}
      <ClickableContainer onClick={showSetupModal} className='text-primary px-1 '>
        {t.COURSE_ANALYTICS.PRE_POST.LINK()}
      </ClickableContainer>
      {suffix}
    </div>
  );
};

export default EmptyReport;
